/**
 * Tilläggsavtal – Hyresgästanpassning · Version 2026 —
 * tillaggsavtal_hyresgastanpassning v1 (Formulär R-09).
 *
 * Connected child of a lokalhyresavtal (not a bilaga): its own document and
 * its own signing. Parties, property and the parent avtalsnummer are
 * inherited from the lease.
 */
import { applyDefaults, COMPOSITION_SCHEMA, COMPOSITION_VERSION } from '@hyranai/regta-document-ir';
import { declaredSectionInstances } from '../common/index.js';
import { TILLAGGSAVTAL_HYRESGASTANPASSNING_BLOCKS } from '../tillaggsavtal_hyresgastanpassning/blocks.js';
const K = 'tillaggsavtal_hyresgastanpassning';
const TITLE = 'Tilläggsavtal – Hyresgästanpassning · Version 2026';
const FORM_NUMBER = 'Formulär R-09';
const PREAMBLE = 'Hyresvärden och Hyresgästen omnämns nedan gemensamt som "Parterna" och var ' +
    'för sig som "Hyresvärden" respektive "Hyresgästen". Den lokal som avses i ' +
    'ovan angivet hyresavtal omnämns nedan som "Lokalen". Detta tilläggsavtal ' +
    'utgör bilaga till och ska läsas tillsammans med hyresavtalet. Vid ' +
    'motstridighet äger detta tilläggsavtal företräde framför hyresavtalet.';
const SLOTS = TILLAGGSAVTAL_HYRESGASTANPASSNING_BLOCKS.flatMap((b) => b.slots);
export const tillaggsavtalHyresgastanpassningV1 = (values = {}) => ({
    schema: COMPOSITION_SCHEMA,
    version: COMPOSITION_VERSION,
    documentKey: 'tillaggsavtal_hyresgastanpassning',
    documentVersion: 'v1',
    title: TITLE,
    locale: 'sv-SE',
    meta: {
        category: 'Lokalhyra',
        numberStyle: 'paragraph',
        shortTitle: 'Tilläggsavtal Hyresgästanpassning',
        formNumber: FORM_NUMBER,
        preamble: PREAMBLE,
        description: 'Tilläggsavtal som reglerar hyresgästanpassning av lokalen. Välj mellan ' +
            'tre alternativ: investeringsbidrag (A1), hyresvärden genomför (A2), ' +
            'eller hyresgästen genomför på egen bekostnad (A3).\n\n' +
            'Kopplad mall — skapas under det lokalhyresavtal som anpassningen avser. ' +
            'Det är ett eget dokument med egen signering (inte en bilaga) och visas i ' +
            'avtalslistan. Parternas uppgifter och lokalens adress förifylls från ' +
            'lokalavtalet.',
        status: 'active',
        signingMode: 'digital',
        signingPlacementAnchors: 'per-party-label',
        connectedTo: ['lokalhyra'],
        inheritFromParent: {
            parties: 'by-role-ordinal',
            property: true,
            values: [{ key: 'parent_contract_number', fromParentKey: 'contract_number' }],
        },
        partySlots: [
            { id: 'lessor', label: 'Hyresvärd', role: 'lessor', ordinal: 0, required: true, signs: true },
            { id: 'lessee', label: 'Hyresgäst', role: 'lessee', ordinal: 0, required: true, signs: true },
        ],
        propertySlots: [{ id: 'property', label: 'Fastighet', multi: false, required: true }],
    },
    values: applyDefaults({ fields: SLOTS }, values),
    blocks: [
        { instanceId: 'letterhead', blockRef: 'common.letterhead@v1', slot: 'letterhead', input: { title: TITLE, form_number: FORM_NUMBER } },
        { instanceId: 'footer', blockRef: 'common.page-footer@v1', slot: 'footer', input: { form_number: FORM_NUMBER } },
        { instanceId: 'preamble', blockRef: 'common.preamble@v1', input: { text: PREAMBLE } },
        ...declaredSectionInstances([
            { ref: 'avtalskoppling', blockRef: `${K}.avtalskoppling@v1` },
            { ref: 'hyresgastanpassning', blockRef: `${K}.hyresgastanpassning@v1` },
            { ref: 'foretradesordning', blockRef: `${K}.foretradesordning@v1` },
            { ref: 'skriftlighet', blockRef: `${K}.skriftlighet@v1` },
            { ref: 'tvist', blockRef: `${K}.tvist@v1` },
            {
                ref: 'underskrift',
                blockRef: `${K}.underskrifter@v1`,
                input: {
                    ref: 'underskrift',
                    title: 'Underskrifter',
                    statement: true,
                    parties: [
                        { label: 'Hyresvärd', role: 'lessor', ordinal: 0 },
                        { label: 'Hyresgäst', role: 'lessee', ordinal: 0 },
                    ],
                },
            },
            { ref: 'bilagor', blockRef: `${K}.bilagor@v1` },
        ], { customBlockRef: `${K}.custom-sections@v1` }),
    ],
});
//# sourceMappingURL=tillaggsavtal_hyresgastanpassning.js.map